import React, { Component } from 'react';
import dateFormat from 'dateformat';
import { navigateTo } from '../utils/navigation';

var config = process.env;

class ProviderStockCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            // Sólo lo usa la card de "sin stock en proveedor": si el usuario ya la abrió o cerró.
            oosToggled: false,
            loading: false,
            modalItems: [],
            showModal: false
        };
    }

    toggleExpanded = () => {
        this.setState(prev => ({ expanded: !prev.expanded }));
    }

    openModal = () => {
        this.setState({
            showModal: true,
            modalItems: this.props.provider.items.map(item => ({
                ...item,
                selected: true,
                // Si hay sugerencia de stockeo, es la cantidad que cubre el quiebre esperado del
                // proveedor y manda sobre el `quantityToOrder` de reposición normal.
                quantity: item.stockupSuggestion && item.stockupSuggestion.suggestedUnits > 0
                    ? item.stockupSuggestion.suggestedUnits
                    : item.quantityToOrder
            }))
        });
    }

    closeModal = () => {
        this.setState({ showModal: false });
    }

    toggleItem = (code) => {
        this.setState(prev => ({
            modalItems: prev.modalItems.map(i =>
                i.code === code ? { ...i, selected: !i.selected } : i
            )
        }));
    }

    updateQuantity = (code, value) => {
        const quantity = parseInt(value) || 1;
        this.setState(prev => ({
            modalItems: prev.modalItems.map(i =>
                i.code === code ? { ...i, quantity } : i
            )
        }));
    }

    createOrder = () => {
        const { provider } = this.props;
        const selectedItems = this.state.modalItems.filter(i => i.selected);
        if (selectedItems.length === 0) return;

        this.setState({ loading: true });

        const request = {
            method: 'POST',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                providerId: provider.providerId,
                items: selectedItems.map(i => ({
                    code: i.code,
                    productType: i.productType,
                    name: i.name,
                    stockAtOrder: i.stock,
                    suggestedStock: i.suggestionStock,
                    quantityToOrder: i.quantity
                }))
            })
        };

        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider-orders', request)
        .then(res => res.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error === 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
                this.setState({ loading: false });
            } else {
                navigateTo('/providerOrders');
            }
        });
    }

    handleMarkItemOutOfStock = (item) => {
        if (this.props.onMarkOutOfStock) {
            this.props.onMarkOutOfStock(
                [{ code: item.code, productType: item.productType }],
                this.props.provider.providerId
            );
        }
    }

    renderStatusBadge = (item) => {
        if (item.atMinimum) {
            return <span className="badge badge-danger">&#9888; Mínimo</span>;
        }
        return <span className="badge badge-warning">Bajo recomendado</span>;
    }

    renderModal = () => {
        const { provider } = this.props;
        const { modalItems, loading, showModal } = this.state;
        const anySelected = modalItems.some(i => i.selected);

        if (!showModal) return null;

        return (
            <>
                <div className="modal show" role="dialog" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Nuevo pedido — {provider.providerName}</h4>
                            </div>
                            <div className="modal-body" style={{ padding: '0 1rem 1rem 1rem', maxHeight: '60vh', overflowY: 'auto' }}>
                                <table className="transaction-history dataTable no-footer dtr-inline" style={{ width: '100%' }}>
                                    <thead>
                                        <tr role="row">
                                            <th style={{ width: '5%' }}></th>
                                            <th style={{ width: '45%' }}>Producto</th>
                                            <th style={{ width: '15%' }}>Stock actual</th>
                                            <th style={{ width: '15%' }}>Recomendado</th>
                                            <th style={{ width: '20%' }}>A pedir</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {modalItems.map((item, idx) => (
                                            <tr role="row" className="odd" key={item.code} style={{ background: idx % 2 === 0 ? '#ffffff' : '#fcfcfc', opacity: item.selected ? 1 : 0.4 }}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={item.selected}
                                                        onChange={() => this.toggleItem(item.code)}
                                                    />
                                                </td>
                                                <td>
                                                    {item.name}
                                                    {item.stockupSuggestion && (
                                                        <div style={{ fontSize: '11px', color: '#007bff' }}>
                                                            sugerido por quiebre del proveedor
                                                        </div>
                                                    )}
                                                </td>
                                                <td>{item.stock}</td>
                                                <td>{item.suggestionStock}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={item.quantity}
                                                        min="1"
                                                        disabled={!item.selected}
                                                        onChange={e => this.updateQuantity(item.code, e.target.value)}
                                                        style={{ width: '80px' }}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary btn-sm" onClick={this.closeModal}>Cancelar</button>
                                <button
                                    className="btn btn-primary btn-sm"
                                    disabled={loading || !anySelected}
                                    onClick={this.createOrder}
                                >
                                    {loading ? 'Creando...' : 'Confirmar pedido'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show" onClick={this.closeModal}></div>
            </>
        );
    }

    renderOutOfStockCard = () => {
        const { provider, discrepancies } = this.props;
        const { expanded, oosToggled } = this.state;

        // Cuáles de las discrepancias de la pantalla son de ESTE proveedor. Se cruza por
        // `oosId`, que es la fila de provider_out_of_stock: cruzar por código de producto
        // fallaría con un producto marcado para dos proveedores distintos.
        const idsRevisar = new Set((discrepancies || []).map((d) => d.oosId));
        const revisar = (provider.items || []).filter((item) => idsRevisar.has(item.oosId)).length;

        // Si hay algo que decidir, la card arranca ABIERTA. Colapsada es exactamente cómo se
        // pierde de vista lo único que pide una acción. Pero es sólo el default: si el usuario
        // la tocó, manda lo que eligió (antes `expanded || revisar > 0` la dejaba imposible de
        // cerrar mientras hubiera algo para revisar).
        const abierta = oosToggled ? expanded : revisar > 0;

        return (
            <div className="card card-small mb-3" style={{ borderLeft: revisar > 0 ? '4px solid #007bff' : '4px solid #adb5bd', opacity: revisar > 0 ? 1 : 0.75 }}>
                <div
                    className="card-header"
                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    onClick={() => this.setState({ expanded: !abierta, oosToggled: true })}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ color: '#adb5bd', fontWeight: 'bold', fontSize: '16px' }}>●</span>
                        <strong className="text-muted">{provider.providerName}</strong>
                        <span className="badge badge-secondary">{provider.items.length} producto(s)</span>
                        {/* La contradicción es lo único que EXIGE decidir, y estaba sólo en una card
                            arriba de la pantalla: si el proveedor venía colapsado, no se veía. Acá
                            queda pegada al proveedor que la genera, en color de acción. */}
                        {revisar > 0 && (
                            <span className="badge badge-primary" title="El proveedor volvió a publicarlos con stock: hay que decidir">
                                {revisar} para revisar
                            </span>
                        )}
                    </div>
                    <i className="material-icons" style={{ cursor: 'pointer', color: '#adb5bd' }}>
                        {abierta ? 'expand_less' : 'expand_more'}
                    </i>
                </div>

                {abierta && (
                    <div className="card-body" style={{ padding: '0' }}>
                        <div className="dataTables_wrapper no-footer" style={{ padding: '0 1rem 1rem 1rem' }}>
                            <table className="transaction-history d-none dataTable no-footer dtr-inline" role="grid" style={{ width: '100%' }}>
                                <thead>
                                    <tr role="row">
                                        <th style={{ width: '30%' }}>Producto</th>
                                        <th style={{ width: '10%' }}>Stock</th>
                                        <th style={{ width: '10%' }}>Recom.</th>
                                        <th style={{ width: '20%' }}>Marcado</th>
                                        <th style={{ width: '20%' }}>Se reactiva</th>
                                        <th style={{ width: '10%' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {provider.items.map((item, idx) => {
                                        const enRevision = idsRevisar.has(item.oosId);
                                        return (
                                        <tr role="row" className="odd" key={item.code} style={{ background: enRevision ? '#eaf3ff' : (idx % 2 === 0 ? '#ffffff' : '#fcfcfc') }}>
                                            <td>
                                                {item.name}
                                                {' '}
                                                {item.source === 'auto'
                                                    ? <span className="badge badge-info" title="El proveedor dejó de publicarlo con stock. Se levanta solo cuando vuelva a tenerlo.">confirmado por el proveedor</span>
                                                    : <span className="badge badge-light" title="Lo marcó una persona. Vence a los 30 días.">marcado a mano</span>}
                                                {enRevision && (
                                                    <span className="badge badge-primary ml-1" title="El proveedor volvió a publicarlo con stock: decidí si vuelve al circuito">
                                                        el proveedor lo repuso
                                                    </span>
                                                )}
                                            </td>
                                            <td>{item.stock}</td>
                                            <td>{item.suggestionStock}</td>
                                            <td className="text-muted">{dateFormat(item.markedAt, "dd/mm/yyyy")}</td>
                                            <td className="text-muted">
                                                {/* El marcado automático guarda un expires_at deliberadamente lejano (año 9999)
                                                    porque no vence por tiempo: mostrar esa fecha sería ruido sin sentido. */}
                                                {item.source === 'auto'
                                                    ? <em>cuando el proveedor reponga</em>
                                                    : dateFormat(item.expiresAt, "dd/mm/yyyy")}
                                            </td>
                                            <td>
                                                {/* Reactivar a mano un marcado automático no tiene sentido: la próxima corrida
                                                    lo volvería a marcar, porque el proveedor sigue sin tenerlo. */}
                                                {item.source === 'auto' ? (
                                                    <span className="text-muted" style={{ fontSize: '12px' }}>—</span>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-primary"
                                                        onClick={() => this.props.onReactivate(item.oosId)}
                                                    >
                                                        Reactivar
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    renderNonOrderableCard = () => {
        const { provider } = this.props;
        const { expanded } = this.state;

        return (
            <div className="card card-small mb-3" style={{ borderLeft: '4px solid #6c757d', opacity: 0.65 }}>
                <div
                    className="card-header"
                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    onClick={this.toggleExpanded}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ color: '#6c757d', fontWeight: 'bold', fontSize: '16px' }}>●</span>
                        <strong className="text-muted">{provider.providerName}</strong>
                        <span className="badge badge-dark">{provider.items.length} producto(s) bajo stock</span>
                    </div>
                    <i className="material-icons" style={{ cursor: 'pointer', color: '#6c757d' }}>
                        {expanded ? 'expand_less' : 'expand_more'}
                    </i>
                </div>

                {expanded && (
                    <div className="card-body" style={{ padding: '0' }}>
                        <div className="dataTables_wrapper no-footer" style={{ padding: '0 1rem 1rem 1rem' }}>
                            <table className="transaction-history d-none dataTable no-footer dtr-inline" role="grid" style={{ width: '100%' }}>
                                <thead>
                                    <tr role="row">
                                        <th style={{ width: '40%' }}>Producto</th>
                                        <th style={{ width: '15%' }}>Stock</th>
                                        <th style={{ width: '15%' }}>Mín</th>
                                        <th style={{ width: '15%' }}>Recom.</th>
                                        <th style={{ width: '15%' }}>Faltan</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {provider.items.map((item, idx) => (
                                        <tr role="row" className="odd" key={item.code} style={{ background: idx % 2 === 0 ? '#ffffff' : '#fcfcfc' }}>
                                            <td>{item.name}</td>
                                            <td>{item.stock}</td>
                                            <td>{item.minStock}</td>
                                            <td>{item.suggestionStock}</td>
                                            <td><strong>{item.quantityToOrder}</strong></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    render() {
        if (this.props.nonOrderable) {
            return this.renderNonOrderableCard();
        }

        if (this.props.outOfStock) {
            return this.renderOutOfStockCard();
        }

        const { provider } = this.props;
        const { expanded, loading } = this.state;
        const borderColor = provider.triggered ? '#c4183c' : '#ffb400';
        const badgeClass = provider.triggered ? 'badge-danger' : 'badge-warning';
        const badgeText = provider.triggered
            ? `${provider.items.filter(i => i.atMinimum).length} producto(s) en mínimo`
            : `${provider.items.length} producto(s) bajo recomendado`;

        return (
            <div className="card card-small mb-3" style={{ borderLeft: `4px solid ${borderColor}` }}>
                <div
                    className="card-header"
                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    onClick={this.toggleExpanded}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ color: borderColor, fontWeight: 'bold', fontSize: '16px' }}>●</span>
                        <strong>{provider.providerName}</strong>
                        <span className={`badge ${badgeClass}`}>{badgeText}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} onClick={e => e.stopPropagation()}>
                        <button
                            type="button"
                            className={`btn btn-sm ${provider.triggered ? 'btn-danger' : 'btn-secondary'}`}
                            disabled={!provider.triggered || loading}
                            onClick={this.openModal}
                        >
                            Crear pedido
                        </button>
                        <i className="material-icons" onClick={this.toggleExpanded} style={{ cursor: 'pointer' }}>
                            {expanded ? 'expand_less' : 'expand_more'}
                        </i>
                    </div>
                </div>

                {expanded && (
                    <div className="card-body" style={{ padding: '0' }}>
                        <div className="dataTables_wrapper no-footer" style={{ padding: '0 1rem 1rem 1rem' }}>
                            <table className="transaction-history d-none dataTable no-footer dtr-inline" role="grid" style={{ width: '100%' }}>
                                <thead>
                                    <tr role="row">
                                        <th tabIndex="0" style={{ width: '30%' }}>Producto</th>
                                        <th tabIndex="0" style={{ width: '10%' }}>Stock</th>
                                        <th tabIndex="0" style={{ width: '10%' }}>Mín</th>
                                        <th tabIndex="0" style={{ width: '10%' }}>Recom.</th>
                                        <th tabIndex="0" style={{ width: '10%' }}>A pedir</th>
                                        <th tabIndex="0" style={{ width: '20%' }}>Estado</th>
                                        <th tabIndex="0" style={{ width: '10%' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {provider.items.map((item, idx) => (
                                        <tr role="row" className="odd" key={item.code} style={{ background: idx % 2 === 0 ? '#ffffff' : '#fcfcfc' }}>
                                            <td>
                                                {item.name}
                                                {item.stockupSuggestion && (
                                                    <div style={{ fontSize: '11px', color: '#007bff', marginTop: '2px' }}>
                                                        <i className="material-icons" style={{ fontSize: '12px', verticalAlign: 'middle' }}>lightbulb_outline</i>
                                                        {' '}Sugerido: pedir {item.stockupSuggestion.suggestedUnits}
                                                        {' '}<span className="text-muted">({item.stockupSuggestion.reason})</span>
                                                    </div>
                                                )}
                                            </td>
                                            <td>{item.stock}</td>
                                            <td>{item.minStock}</td>
                                            <td>{item.suggestionStock}</td>
                                            <td><strong>{item.quantityToOrder}</strong></td>
                                            <td>{this.renderStatusBadge(item)}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-secondary"
                                                    style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '12px', padding: '2px 8px' }}
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="El proveedor no tiene stock de este producto. Se oculta del monitor y vuelve a aparecer en 30 días."
                                                    onClick={() => this.handleMarkItemOutOfStock(item)}
                                                >
                                                    <i className="material-icons" style={{ fontSize: '14px' }}>remove_shopping_cart</i>
                                                    <span>Proveedor sin stock</span>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {this.renderModal()}
            </div>
        );
    }
}

export default ProviderStockCard;
